import { useCallback, useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { UserRole } from "../_statics/UserStatics";
import { adminAreaActions } from "../admin/services/store/adminarea.actions";

const useOrganizationNames = () => {
    const dispatch = useDispatch();
    const user = useSelector((state) => state.authentication.user);
    const organizationNames = useSelector((state) => state.adminArea?.organizationNames);
    const loading = useSelector((state) => !!state.adminArea?.organizationNamesLoading);
    const failed = useSelector((state) => !!state.adminArea?.organizationNamesFailed);
    const stale = useSelector((state) => !!state.adminArea?.organizationNamesStale);

    const isSuperUser = user?.userRole === UserRole.SUPER_USER || user?.userRole === UserRole.TECHNICAL_USER;
    const authenticated = !!user?.access_token;

    useEffect(() => {
        if (!isSuperUser || !authenticated || (organizationNames && !stale) || loading || failed) return;
        dispatch(adminAreaActions.getOrganizationNames());
    }, [dispatch, isSuperUser, authenticated, organizationNames, stale, loading, failed]);

    const reload = useCallback(() => {
        if (!isSuperUser || !authenticated || loading) return;
        dispatch(adminAreaActions.getOrganizationNames());
    }, [dispatch, isSuperUser, authenticated, loading]);

    const organizations = useMemo(() => {
        if (!isSuperUser || !Array.isArray(organizationNames?.organizations)) return null;
        const vipSupport = new Set(organizationNames.vipSupportOrganizationUUIDs || []);
        return organizationNames.organizations.map((organization) => ({
            externalUUID: organization.externalUUID,
            name: organization.name,
            hasActiveVipSupport: vipSupport.has(organization.externalUUID),
        }));
    }, [isSuperUser, organizationNames]);

    return { organizations, loading: isSuperUser && loading, failed: isSuperUser && failed, reload, isSuperUser };
};

export default useOrganizationNames;
